<div class="verify-wrapper" style="display: flex; justify-content: center; align-items: center; min-height: 100vh; background-color: #f3f3f9;">
  <table class="body-wrap" style="font-family: 'Roboto', sans-serif; width: 100%; background-color: transparent; margin: 0;">
    <tr>
      <td></td>

      <td class="container" width="600" style="display: block !important; max-width: 600px !important; margin: 0 auto;">
        <div class="content" style="max-width: 600px; margin: 0 auto; padding: 20px;">

          <table class="main" width="100%" cellpadding="0" cellspacing="0" style="border-radius: 7px; border: none;">
            <tr>
              <td class="content-wrap" style="color: #495057; background-color: #fff; padding: 30px; border-radius: 7px; box-shadow: 0 3px 15px rgba(30,32,37,.06);">

                <!-- Logo -->
                <div style="text-align: center; margin-bottom: 20px;">
                  <img src="assets/images/logo-dark.png" alt="logo" height="50">
                </div>

                <!-- Vérification en cours -->
                <div *ngIf="verifying" style="text-align: center;">
                  <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;"></div>
                  <h4 style="font-weight: 500;">Vérification en cours...</h4>
                  <p style="color: #878a99;">Veuillez patienter pendant la vérification de votre adresse email.</p>
                </div>

                <!-- Succès -->
                <div *ngIf="!verifying && success" style="text-align: center;">
                  <i class="fas fa-check-circle" style="font-size: 60px; color: #28a745; margin-bottom: 10px;"></i>

                  <h4 style="font-weight: 500; margin-bottom: 10px;">Email vérifié avec succès !</h4>
                  <p style="color: #878a99; margin-bottom: 25px;">
                    Votre adresse email a été vérifiée. Vous pouvez maintenant accéder à votre compte.
                  </p>

                  <button (click)="goToLogin()"
                    style="font-size: .8125rem; color: #FFF; text-decoration: none; border-radius: .25rem;
                    background-color: #405189; border: 1px solid #405189; padding: .5rem .9rem;">
                    Se connecter
                  </button>
                </div>

                <!-- Erreur -->
                <div *ngIf="!verifying && !success" style="text-align: center;">
                  <i class="fas fa-times-circle" style="font-size: 60px; color: #dc3545; margin-bottom: 10px;"></i>

                  <h4 style="font-weight: 500; color: #dc3545; margin-bottom: 10px;">
                    Échec de la vérification
                  </h4>

                  <p style="color: #878a99; margin-bottom: 20px;">
                    {{ errorMessage }}
                  </p>

                  <div style="margin-top: 20px;">
                    <button (click)="goToLogin()"
                      style="margin-right: 10px; font-size: .8125rem; background: transparent; border: 1px solid #405189;
                      border-radius: .25rem; padding: .5rem .9rem; cursor: pointer;">
                      Retour à la connexion
                    </button>

                    <button (click)="openResendVerificationModal()"
                      style="font-size: .8125rem; color: #FFF; background-color: #405189;
                      border: 1px solid #405189; border-radius: .25rem; padding: .5rem .9rem;">
                      Renvoyer l'email
                    </button>
                  </div>
                </div>

              </td>
            </tr>
          </table>

          <!-- Footer -->
          <div style="text-align: center; margin: 25px auto 0; font-family: 'Roboto', sans-serif;">
            <h4 style="font-weight: 500;">Besoin d'aide ?</h4>
            <p style="color: #878a99;">
              Contactez le support à
              <a href="#" style="font-weight: 500;">info@sapptrading.com</a>
            </p>
            <p style="font-size: 14px; color: #98a6ad; margin: 0;">
              © {{ currentYear }} SA. Tous droits réservés.
            </p>
          </div>

        </div>
      </td>

      <td></td>
    </tr>
  </table>
</div>
